var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.vErrors.has(_vm.field),
          expression: "vErrors.has(field)"
        }
      ],
      staticClass: "validation-error-label"
    },
    [_vm._v(_vm._s(_vm.message))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }